import React, {useState} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/about/mission.png";
import Img1 from "../../images/about/vision.webp";
import Img2 from "../../images/about/Values.webp";
import {Col, Container, Row} from "react-bootstrap";

function AboutTek({data}) {
    const [activeTab, setActiveTab] = useState(0);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }
    return (
        <div className="p-100 pt-0">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <ul className="custom_tab">
                            <li onClick={() => {
                                displayTab(0)
                            }} className={`tabs ${activeTab === 0 ? 'active' : ''}`}>
                                <div className="example" data-text="Mission">
                                    <h2>Mission</h2>
                                </div>
                            </li>

                            <li onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="example" data-text="Vision">
                                    <h2>Vision</h2>
                                </div>
                            </li>
                            <li onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="example" data-text="Values">
                                    <h2>Values</h2>
                                </div>
                            </li>
                        </ul>
                        <Row className={activeTab === 0 ? 'd-flex h-100' : 'd-none h-100'}>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <div>
                                    <h4>To be forever curious and impactful in revolutionizing technology for our partner</h4>
                                    <p>We aspire to create and deliver the best digital solutions for businesses wanting to acquire a competitive edge in the industry and serve their customers through robust digital channels.</p>
                                    <p>TekRevol aims to help startups and organizations recognize their potential and leverage optimum, highly customized solutions for business growth and ROI.</p>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <LazyLoadImage
                                    src={Img}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </Col>
                        </Row>
                        <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <div>
                                    <h4>Transforming the world through technologies that disrupt</h4>
                                    <p>We aim to extend the scope of current technologies into societal issues and deliver back to the community for the greater good.</p>
                                    <p>Our vision is to help 20 million lives with better education and employment opportunities, acquire ten active ventures, scale five businesses to exit, get listed to Nasdaq, become the most preferred workplace in Pakistan, and enter the Fortune 500 club in the next five years.</p>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </Col>
                        </Row>
                        <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <div>
                                        <h4>Curiosity</h4>
                                        <p>We encourage our team members to question the norm and explore innovative solutions to problems.</p>
                                        <h4>Honesty</h4>
                                        <p>We value integrity and ethical behavior in all our interactions, both internally and externally.</p>
                                        <h4>Positivity</h4>
                                        <p>We value the power of positivity and believe that it leads to higher productivity, creativity, and job satisfaction.</p>
                                        <h4>Impact</h4>
                                        <p>We strive to make a meaningful impact in everything we do at TekRevol. </p>
                                        <h4>Disruption</h4>
                                        <p>We believe that disruptive innovation is the key to solving complex problems and creating new opportunities.</p>

                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                                <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AboutTek;